// The user's chosen city for "cheapest near you", persisted in local storage.
//
// This is the FALLBACK to browser geolocation (Slice E): when we don't have (or
// the user declined) a precise location, they can name their city and we scope
// prices to that city's stores. Empty = national (chain-level) prices.

const STORAGE_KEY = 'cityPref'

export function getCity() {
  try {
    return localStorage.getItem(STORAGE_KEY) || ''
  } catch {
    return ''
  }
}

export function setCity(city) {
  try {
    const trimmed = (city || '').trim()
    if (trimmed) {
      localStorage.setItem(STORAGE_KEY, trimmed)
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  } catch {
    /* ignore */
  }
  return getCity()
}

// A few common Croatian cities for the picker's datalist (convenience only —
// the field is free-text and the backend matches diacritic-insensitively).
export const COMMON_CITIES = [
  'Zagreb', 'Split', 'Rijeka', 'Osijek', 'Zadar', 'Slavonski Brod',
  'Pula', 'Karlovac', 'Varaždin', 'Šibenik', 'Dubrovnik',
]
